import { OrderRouteItem } from '@aloft/toolkit-shared';

import { useLocation } from 'react-router-dom';

import { selectDeviceWidth } from '../../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { craftsmanUIHeaderNavItems } from './constants.ts';
import { SubNavItemType, hasSubnav } from './types.ts';

export const useActiveSubNav = (): SubNavItemType[] | undefined => {
  const deviceWidth = useAppSelector(selectDeviceWidth);
  const location = useLocation();
  const pathParts = location.pathname.split('/');

  // no subnav in mobile views for now
  if (deviceWidth === 'phone') return undefined;

  const primaryRoute = pathParts[3];

  const activeNavItem = primaryRoute
    ? craftsmanUIHeaderNavItems[primaryRoute as OrderRouteItem]
    : undefined;

  return hasSubnav(activeNavItem) ? activeNavItem.subnav : undefined;
};
